import { lightShadowBlue } from 'theme/color';
import { fontsize32, poppins300, poppins500 } from 'theme/common.style';

export const offerValue = () => ({
  ...poppins500,
  ...fontsize32,
  paddingBottom: '10px',
});

export const offerCenterCont = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  marginTop: '20px',
  padding: '14px 10px',
  borderRadius: '15px',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
};

export const counterBtn = {
  borderColor: 'none',
  borderRadius: '54px',
  textAlign: 'center',
  padding: '12px 10px',
  background: 'rgba(249, 57, 57, 0.1)',
  color: '#F93939',
  overflow: 'hidden',
  'text-overflow': 'ellipsis',
  'white-space': 'nowrap',
  width: '210px',
  height: '41px',
};

export const liveAvatarStatus = {
  display: 'flex',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
  paddingTop: '10px',
};
export const liveDTag = {
  ...poppins300,
  fontSize: '14px',
  background: lightShadowBlue,
  textAlign: 'center',
  borderRadius: '8px',
  width: '24px',
  color: '#9C9C9C',
  // border: "1px solid ",
};
export const counterLiveDTag = {
  ...poppins300,
  fontSize: '14px',
  background: '#9CC4FF',
  textAlign: 'center',
  width: '24px',
  color: 'white',
  // border: "1px solid ",
};
